
try {
  // beatline_survival_click_bridge_v9
  const w = window as any;
  w.beatlineSurvivalNextCardClick = function() {
    w.__beatlineSurvivalAllowNextDraw = true;
    if (typeof w.drawCard === 'function') {
      return w.drawCard();
    }
  };
} catch (_) {}

try { (window as any).__beatlineSurvivalBuildMarker = 'beatline_survival_build_marker_v5'; } catch (_) {}

// beatline_light_confetti_guard_v1
function installBeatLineLightConfettiGuard(): void {
  const w = window as unknown as {
    confetti?: any;
    __beatlineLightConfettiGuardInstalled?: boolean;
    __beatlineLightConfettiResetTimer?: number;
  };

  if (w.__beatlineLightConfettiGuardInstalled) return;
  if (typeof w.confetti !== 'function') return;

  const original = w.confetti;

  const normalizeOptions = (value: any): any => {
    if (!value || typeof value !== 'object' || Array.isArray(value)) return value;

    const next = { ...value };
    const count = Number(next.particleCount || 0);

    if (count >= 170) {
      next.particleCount = 55;
    } else if (count >= 120) {
      next.particleCount = 45;
    } else if (count >= 80) {
      next.particleCount = 35;
    }

    const ticks = Number(next.ticks || 0);
    next.ticks = ticks > 0 ? Math.min(ticks, 90) : 75;

    const scalar = Number(next.scalar || 0);
    next.scalar = scalar > 0 ? Math.min(scalar, 0.85) : 0.75;

    next.disableForReducedMotion = true;

    return next;
  };

  const wrapped = function (...args: any[]): unknown {
    const mapped = args.map(normalizeOptions);

    try {
      if (typeof original.reset === 'function') {
        original.reset();
      }
    } catch (_) {}

    const result = original.apply(w, mapped);

    try {
      if (w.__beatlineLightConfettiResetTimer) {
        window.clearTimeout(w.__beatlineLightConfettiResetTimer);
      }

      w.__beatlineLightConfettiResetTimer = window.setTimeout(() => {
        try {
          if (typeof original.reset === 'function') {
            original.reset();
          }
        } catch (_) {}
      }, 2200);
    } catch (_) {}

    return result;
  } as any;

  if (typeof original.reset === 'function') {
    wrapped.reset = original.reset.bind(original);
  }

  w.confetti = wrapped;
  w.__beatlineLightConfettiGuardInstalled = true;
}

import { appendScript } from './assets';
import { createDomReadyReplay } from './domReadyReplay';
import { installBundledBeatLineStyles } from './bundledStyles';
import { executeClassicScript } from './inlineClassicScript';
import legacyRuntimeSource from './snapshots/legacy-runtime.snapshot.js?raw';
import pushBridgeSource from './snapshots/push-bridge.snapshot.js?raw';
import type { BeatLineViteConfig } from '../api/types';
import { createCardHTML } from '../game/cardHtml';
import { setPlayingUI } from '../ui/visualizer';
import { setPlaybackButtonState } from '../audio/playback';
import { updateUIFromTypeScript } from '../game/updateUI';
import { drawCardFromTypeScript } from '../game/drawCard';
import { initiateCheckFromTypeScript } from '../game/check';
import { finalizeTurnFromTypeScript, nextTurnFromTypeScript, resolveTurnFromTypeScript, updateScoresFromTypeScript } from '../game/turn';
import { openInterventionDecisionFromTypeScript, resolveInterventionFromTypeScript, checkChallengeFromTypeScript, renderChallengeUIFromTypeScript, restoreInterventionUIFromTypeScript, getOfflineChallengersFromTypeScript } from '../game/intervention';
import { actionBuyCardFromTypeScript, actionFreeCardFromTypeScript } from '../game/tokens';
import { initSortableFromTypeScript, setDragEnabledFromTypeScript } from '../game/sortable';
import { showBonusModalFromTypeScript, closeModalFromTypeScript } from '../ui/modals';
import { endGameFromTypeScript, replayFromTypeScript, endTimeAttackFromTypeScript, endSurvivalFromTypeScript, endSpeedrunFromTypeScript } from '../game/win';
import { setTimeAttackUIFromTypeScript, updateTimeAttackTimerFromTypeScript, setSpeedrunUIFromTypeScript, updateSpeedrunTimerFromTypeScript, setSurvivalUIFromTypeScript, updateSurvivalLivesUIFromTypeScript, setPerfectOrderUIFromTypeScript, applyPerfectOrderCardColorsFromTypeScript, continueSpecialModeFromTypeScript } from '../game/specialModes';
import { resetBoardForNewGameFromTypeScript } from '../ui/leaveReset';
import { installPostLegacyRuntimeFixes } from '../ui/appRuntimeFixes';

const CDN = {
  jquery: 'https://code.jquery.com/jquery-3.7.1.min.js',
  youtube: 'https://www.youtube.com/iframe_api',
  sortable: 'https://cdnjs.cloudflare.com/ajax/libs/Sortable/1.14.0/Sortable.min.js',
  confetti: 'https://cdn.jsdelivr.net/npm/canvas-confetti@1.5.1/dist/confetti.browser.min.js',
  firebaseApp: 'https://www.gstatic.com/firebasejs/9.22.2/firebase-app-compat.js',
  firebaseAuth: 'https://www.gstatic.com/firebasejs/9.22.2/firebase-auth-compat.js',
  firebaseDb: 'https://www.gstatic.com/firebasejs/9.22.2/firebase-database-compat.js'
};

function exposeTypeScriptDelegates(): void {
  const w = window as unknown as Record<string, unknown>;
  w.beatlineTsCreateCardHTML = createCardHTML;
  w.beatlineTsSetPlayingUI = setPlayingUI;
  w.beatlineTsSetPlaybackButtonState = setPlaybackButtonState;
  w.beatlineTsUpdateUI = updateUIFromTypeScript;
  w.beatlineTsDrawCard = drawCardFromTypeScript;
  w.beatlineTsInitiateCheck = initiateCheckFromTypeScript;
  w.beatlineTsFinalizeTurn = finalizeTurnFromTypeScript;
  w.beatlineTsResolveTurn = resolveTurnFromTypeScript;
  w.beatlineTsNextTurn = nextTurnFromTypeScript;
  w.beatlineTsUpdateScores = updateScoresFromTypeScript;
  w.beatlineTsOpenInterventionDecision = openInterventionDecisionFromTypeScript;
  w.beatlineTsResolveIntervention = resolveInterventionFromTypeScript;
  w.beatlineTsCheckChallenge = checkChallengeFromTypeScript;
  w.beatlineTsRenderChallengeUI = renderChallengeUIFromTypeScript;
  w.beatlineTsRestoreInterventionUI = restoreInterventionUIFromTypeScript;
  w.beatlineTsGetOfflineChallengers = getOfflineChallengersFromTypeScript;
  w.beatlineTsActionBuyCard = actionBuyCardFromTypeScript;
  w.beatlineTsActionFreeCard = actionFreeCardFromTypeScript;
  w.beatlineTsInitSortable = initSortableFromTypeScript;
  w.beatlineTsSetDragEnabled = setDragEnabledFromTypeScript;
  w.beatlineTsShowBonusModal = showBonusModalFromTypeScript;
  w.beatlineTsCloseModal = closeModalFromTypeScript;
  w.beatlineTsEndGame = endGameFromTypeScript;
  w.beatlineTsReplay = replayFromTypeScript;
  w.beatlineTsEndTimeAttack = endTimeAttackFromTypeScript;
  w.beatlineTsEndSurvival = endSurvivalFromTypeScript;
  w.beatlineTsEndSpeedrun = endSpeedrunFromTypeScript;
  w.beatlineTsSetTimeAttackUI = setTimeAttackUIFromTypeScript;
  w.beatlineTsUpdateTimeAttackTimer = updateTimeAttackTimerFromTypeScript;
  w.beatlineTsSetSpeedrunUI = setSpeedrunUIFromTypeScript;
  w.beatlineTsUpdateSpeedrunTimer = updateSpeedrunTimerFromTypeScript;
  w.beatlineTsSetSurvivalUI = setSurvivalUIFromTypeScript;
  w.beatlineTsUpdateSurvivalLivesUI = updateSurvivalLivesUIFromTypeScript;
  w.beatlineTsSetPerfectOrderUI = setPerfectOrderUIFromTypeScript;
  w.beatlineTsApplyPerfectOrderCardColors = applyPerfectOrderCardColorsFromTypeScript;
  w.beatlineTsContinueSpecialMode = continueSpecialModeFromTypeScript;
  w.beatlineTsResetBoardForNewGame = resetBoardForNewGameFromTypeScript;
}

/**
 * C10: local multiplayer basisflow TypeScript-owned, classic browser-script scope only for remaining legacy/special-mode fallback.
 *
 * Reason: original ui.js and game.js share globals/lexical bindings such as ICONS,
 * t(), tf(), beatlineLang and BEATLINE_SUSPENSE_LINES. ES module imports isolate
 * that scope and broke iTunes playback. The runtime now loads one classic
 * concatenated legacy script, while selected functions still delegate to real TS
 * modules through window.beatlineTs* hooks.
 */
export async function loadTypeScriptBeatLineRuntime(config: BeatLineViteConfig): Promise<void> {
  installBundledBeatLineStyles();

  const replay = createDomReadyReplay();

  if (!window.jQuery) await appendScript(CDN.jquery);
  await appendScript(CDN.youtube).catch(() => undefined);
  if (!(window as unknown as Record<string, unknown>).Sortable) await appendScript(CDN.sortable);
  await appendScript(CDN.confetti).catch(() => undefined);
  installBeatLineLightConfettiGuard();
  if (!(window as unknown as Record<string, unknown>).confetti) (window as unknown as Record<string, unknown>).confetti = function () {};
  await appendScript(CDN.firebaseApp).catch(() => undefined);
  await appendScript(CDN.firebaseAuth).catch(() => undefined);
  await appendScript(CDN.firebaseDb).catch(() => undefined);

  exposeTypeScriptDelegates();
  (window as unknown as Record<string, unknown>).beatlineTsStrictLocalFlow = config.strictLocalMultiplayerTs !== false;
  await executeClassicScript(legacyRuntimeSource, 'beatline-vite-legacy-runtime-c40');
  installPostLegacyRuntimeFixes(config);

  if (config.beatlineSettings?.push && Number((config.beatlineSettings.push as Record<string, unknown>).enabled || 0) === 1) {
    await executeClassicScript(pushBridgeSource, 'beatline-vite-push-bridge-c40').catch(() => undefined);
  }

  replay.flushIfNeeded();
}
